import { Dialog } from '@headlessui/react';
import { MenuAlt3Icon } from '@heroicons/react/solid';
import { Link, NavLink } from '@remix-run/react';
import { useState } from 'react';
import bmsLogo from "~/assets/images/brand-logos/logo-bms.png";
import { classNames } from '~/utils';
// import { Bars3Icon, XMarkIcon } from '@heroicons/react/outline'

const navigation = [
  {
    name: 'Our Platform',
    href: '/platform',
  },
  {
    name: 'Peer Support',
    href: '/peer-support',
  },
  {
    name: 'Mental Health First Aid',
    href: '/mhfa',
  },
  {
    name: 'About Us',
    href: '/about-us',
  },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  return (
    <header className="bg-white">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
        <Link to="/" className="-m-1.5 p-1.5">
          <span className="sr-only">ByMindSide</span>
          <img className="h-12 w-auto" src={bmsLogo} alt="" />
        </Link>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <MenuAlt3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12 lg:items-center">
          {navigation.map((item) => (
            <NavLink key={item.name} to={item.href}
              className={({ isActive }) => classNames(
                isActive
                  ? 'text-lcolor-200'
                  : 'text-gray-900',
                'text-sm font-semibold leading-6'
              )}
            >
              {item.name}
            </NavLink>
          ))}
          <Link to="/contact" className="font-medium px-4 py-2 text-sm text-white bg-lcolor-500 border border-transparent rounded-md shadow-sm hover:bg-lcolor-200">
            Contact
          </Link>
        </div>
      </nav>
      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img className="h-8 w-auto" src={bmsLogo} alt="" />
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <MenuAlt3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    className={({ isActive }) => classNames(
                      isActive
                        ? 'text-lcolor-200'
                        : 'text-gray-900',
                      '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 hover:bg-gray-50'
                    )}
                  >
                    {item.name}
                  </NavLink>
                ))}
              </div>
              <div className="py-6">
                <Link
                  to="/contact"
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}